export enum BpPinLocationTargetEnum {
  plan = 'plan',
  bim  = 'bim'
}
export interface BpPinLocation {
  Type: BpPinLocationTargetEnum,
  ModelId: string
  VersionId: string,
  X: number,
  Y: number,
  Z?: number,
  Marker?: BpMarker,
  AdditionalData?: any
}

export interface BpPin {
  Id?: string;
  Name?: string;
  ExternalId?: string;
  Locations: BpPinLocation[];
}

export interface BpMarker {
  Location?: BpMarkerLocation
}

export interface BpMarkerLocation {
  X?: number,
  Y?: number,
  Z?: number
}
